// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"ManufacturingSchemasList_modalContainer__Sq_vF","customList":"ManufacturingSchemasList_customList__286Pb","avatar":"ManufacturingSchemasList_avatar__1TBua"};